import type { SVGProps } from "react";
import * as React from "react";

const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 12a1 1 0 1 0-2 0zm-1 10v1a1 1 0 0 0 1-1zM4 22H3a1 1 0 0 0 1 1zm1-10a1 1 0 1 0-2 0zM2 7V6a1 1 0 0 0-1 1zm20 0h1a1 1 0 0 0-1-1zm0 5v1a1 1 0 0 0 1-1zM2 12H1a1 1 0 0 0 1 1zm9 10a1 1 0 1 0 2 0zM7.5 7V6zM5 4.5H4zM7.5 2V1zm9 5V6zm0-5v1zM19 12v10h2V12zm1 9H4v2h16zM5 22V12H3v10zM2 8h20V6H2zm19-1v5h2V7zm1 4H2v2h20zM3 12V7H1v5zm10 10V7h-2v15zM12 6H7.5v2H12zM7.5 6a1.5 1.5 0 0 1-1.06-.44L5.024 6.976A3.5 3.5 0 0 0 7.5 8zm-1.06-.44A1.5 1.5 0 0 1 6 4.5H4a3.5 3.5 0 0 0 1.025 2.475zM6 4.5c0-.398.158-.78.44-1.06L5.024 2.024A3.5 3.5 0 0 0 4 4.5zm.44-1.06A1.5 1.5 0 0 1 7.5 3V1a3.5 3.5 0 0 0-2.475 1.025zM7.5 3c1.194 0 2.057.838 2.686 1.982a8.7 8.7 0 0 1 .833 2.21v.006-.001L12 7l.98-.197V6.8l-.001-.005-.004-.016a4 4 0 0 0-.055-.236 10.696 10.696 0 0 0-.982-2.525C11.194 2.662 9.807 1 7.5 1zM12 8h4.5V6H12zm4.5 0a3.5 3.5 0 0 0 2.475-1.025L17.56 5.56A1.5 1.5 0 0 1 16.5 6zm2.475-1.025A3.5 3.5 0 0 0 20 4.5h-2a1.5 1.5 0 0 1-.44 1.06zM20 4.5a3.5 3.5 0 0 0-1.025-2.475L17.56 3.44A1.5 1.5 0 0 1 18 4.5zm-1.025-2.475A3.5 3.5 0 0 0 16.5 1v2a1.5 1.5 0 0 1 1.06.44zM16.5 1c-2.306 0-3.693 1.662-4.439 3.018a10.7 10.7 0 0 0-1.036 2.76l-.004.017V6.8l-.001.002v.001L12 7l.98.197q0 .002 0 0l.001-.005a2 2 0 0 1 .039-.164 8.696 8.696 0 0 1 .794-2.046C14.443 3.838 15.306 3 16.5 3z"
    />
  </svg>
);
export default SvgGift;
